import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { userTypes, userActions } = createActionsStructure('user', [
  { name: 'GET_USERS', async: true },
  { name: 'DELETE_USER', async: true },
  { name: 'CREATE_USER', async: true },
  { name: 'GET_USER_DATA', async: true },
  { name: 'GET_USER_HISTORY', async: true },
  { name: 'CLEAR_USER_DATA', async: false },
  { name: 'SET_USER_HISTORY', async: true },
  { name: 'SET_USER_LINE_ID', async: true },
  { name: 'RESET_USER_PASSWORD', async: true },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/UserActions.js